import { render } from "./LoadingAnimation.vue?vue&type=template&id=ccb565c4&scoped=true"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=ccb565c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb565c4"]])

export default __exports__